import { createFileRoute } from '@tanstack/react-router';

import { SupplierRfqsPage } from '@/features/supplier/rfqs-page';

export const Route = createFileRoute('/_app/supplier/$orgId/rfqs/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierRfqsPage {...params} />;
}
